import { IndexTable, Text, Link, Spinner } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { StatusBadge } from '../Common/StatusBadge';
import { getInventories } from '../../../services/inventoriesService';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const headingMarkup = [
  { title: 'Inventario' },
  { title: 'Fecha inicio' },
  { title: 'Depósito' },
  { title: 'Estado' },
];

const rowMarkup = ({ id, name, startDate, deposit, status }, index) => (
  <IndexTable.Row id={`${id}`} key={id} position={index}>
    <IndexTable.Cell>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Link dataPrimaryLink url={`/deposits/${deposit?.id}/inventories/${id}`}>
          <Text variant="bodyMd" fontWeight="bold" as="span">#{id}</Text>
        </Link>
        <Text variant="bodySm" as="span" color="subdued">{name}</Text>
      </div>
    </IndexTable.Cell>
    <IndexTable.Cell>{formatDate(startDate)}</IndexTable.Cell>
    <IndexTable.Cell>
      <Text variant="bodySm" as="span">{deposit?.name || '-'}</Text>
    </IndexTable.Cell>
    <IndexTable.Cell>
      <StatusBadge type="inventory" status={status} />
    </IndexTable.Cell>
  </IndexTable.Row>
);

const RecentInventoriesDash = ({ data: dataProp }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(!dataProp);
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    if (dataProp?.length) {
      setRows(dataProp.slice(0, 5).map((r, k) => rowMarkup(r, k)));
      setLoading(false);
      return;
    }

    setLoading(true);
    getInventories({ limit: 5, page: 1 })
      .then((r) => {
        const items = r.data?.data || [];
        if (items.length) {
          setRows(items.map((r, k) => rowMarkup(r, k)));
        } else {
          setEmpty(true);
        }
      })
      .catch(() => setEmpty(true))
      .finally(() => setLoading(false));
  }, [dataProp]);

  if (loading) return <div style={{ padding: '16px', textAlign: 'center' }}><Spinner size="small" /></div>;
  if (empty || !rows.length) return <div className="p-4 text-center text-gray-500">Ningún inventario activo</div>;

  return (
    <IndexTable
      resourceName={{ singular: 'inventario', plural: 'inventarios' }}
      itemCount={rows.length}
      headings={headingMarkup}
      selectable={false}
    >
      {rows}
    </IndexTable>
  );
};

export default RecentInventoriesDash;
